import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, computed, inject } from '@angular/core';
import { Router } from '@angular/router';

import { NOTIFICATION_SETTINGS_PERMISSIONS } from '../../../administration/domain/notification-settings/notification-settings.permission.constant';
import { AuthFacade } from '../../../authentication/data-access/facades/auth.facade';
import { NotificationsFacade } from '../../data-access/facades/notifications.facade';
import { NotificationBellComponent } from '../../ui/notification-bell.component';

@Component({
  selector: 'app-notification-bell-container',
  templateUrl: './notification-bell-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NotificationBellComponent],
})
export class NotificationBellContainerComponent implements OnInit, OnDestroy {
  protected readonly notifications = inject(NotificationsFacade);
  private readonly auth = inject(AuthFacade);
  private readonly router = inject(Router);

  protected readonly canOpenSettings = computed(() =>
    this.auth.permissions().includes(NOTIFICATION_SETTINGS_PERMISSIONS.VIEW),
  );

  ngOnInit(): void {
    this.notifications.start();
  }

  protected openChannelsSettings(): void {
    this.notifications.close();
    void this.router.navigateByUrl('/administrador/notificaciones');
  }

  ngOnDestroy(): void {
    this.notifications.stop();
    this.notifications.close();
  }
}
